// Shopify native contact delivery. Local builds do not imply deployment.
(() => {
  const form = document.querySelector('form[data-catering-contact]');
  if (!form) return;
  const button = form.querySelector('button[type="submit"]');
  const feedback = form.querySelector('[data-request-feedback]');
  const body = form.querySelector('[name="contact[body]"]');
  const fields = () => [...form.querySelectorAll('input, select, textarea')]
    .filter(f => f !== body && !/captcha/i.test(f.name) && !['hidden', 'submit', 'button'].includes(f.type));
  const key = 'lanapa-request-' + form.id + '-' + form.dataset.cateringContact;
  const result = form.querySelector('[data-request-result]');
  const savedFields = () => fields().map((f, index) => ({index, value:f.value, checked:f.checked}));
  function saveDraft() {
    try { sessionStorage.setItem(key, JSON.stringify({at:Date.now(), fields:savedFields()})); } catch (_) {}
  }
  if (result?.dataset.requestResult === 'success') {
    try { sessionStorage.removeItem(key); } catch (_) {}
    for (const child of form.children) if (child !== result) child.hidden = true;
    const summary = document.querySelector('.summary');
    if (summary) summary.style.display = 'none';
    button.hidden = true;
    result.focus();
  } else {
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (saved && Date.now() - saved.at < 3600000) {
        const controls = fields();
        for (const item of saved.fields) {
          const control = controls[item.index];
          if (!control) continue;
          control.value = item.value;
          if (typeof item.checked === 'boolean') control.checked = item.checked;
        }
        form.dispatchEvent(new Event('change', {bubbles:true}));
      } else sessionStorage.removeItem(key);
    } catch (_) {}
  }
  function fieldLabel(field) {
    if (field.dataset.name) return field.dataset.name;
    if (field.getAttribute('aria-label')) return field.getAttribute('aria-label');
    const label = field.labels?.[0]?.cloneNode(true);
    if (label) {
      label.querySelectorAll('input, select, textarea, small').forEach(el => el.remove());
      return label.textContent.replace(/\s+/g, ' ').trim();
    }
    return field.id || field.name;
  }
  // Also available to the read-only local QA harness through the generated DOM.
  function prepare() {
    window.refreshCreditPrices?.();
    if (window.coffeeOffer) {
      const request = window.coffeeOffer.preview();
      if (request.ready) { body.value = request.text + '\nSource: ' + location.origin + location.pathname; return; }
    }
    const lines = ['La Ñapa catering inquiry', 'Menu: ' + form.dataset.cateringContact,
      'This is a request only. Availability, final pricing and payment are not confirmed.', ''];
    for (const field of fields()) {
      if (field.disabled || field.closest('[hidden]') || (['checkbox','radio'].includes(field.type) && !field.checked)) continue;
      if ((field.type === 'number' && Number(field.value) === 0) || (field.tagName === 'SELECT' && !field.value)) continue;
      let value = field.tagName === 'SELECT' ? field.selectedOptions[0]?.textContent : field.value;
      if (field.type === 'checkbox') value = field.value === 'on' ? 'Yes' : field.value;
      if (value?.trim()) lines.push(fieldLabel(field) + ': ' + value.trim());
    }
    const summary = document.querySelector('.summary');
    if (summary && form.dataset.cateringContact !== 'Weddings & Special Events') {
      lines.push('', 'ESTIMATE / SELECTED MENU', summary.innerText);
    }
    const view = new URLSearchParams(location.search).get('view');
    lines.push('', 'Source: ' + location.origin + location.pathname + (view ? '?view=' + encodeURIComponent(view) : ''));
    body.value = lines.join('\n');
  }
  if (typeof window.cateringRequestValidate !== 'function') {
    feedback.textContent = 'The order builder did not load. Please reload, or email info@lanapamarket.com.';
    return;
  }
  button.disabled = false;
  // Local preparation only: deliberately no send, checkout, or payment method.
  window.cateringInquiry = Object.freeze({
    preview() {
      const selectionsValid = window.cateringRequestValidate();
      const invalidFields = fields().filter(f => !f.disabled && !f.validity.valid)
        .map(f => ({id: f.id, label: fieldLabel(f), message: f.validationMessage}));
      if (!selectionsValid || invalidFields.length) return {ready:false, invalidFields,
        message:'Complete required fields and check the menu selection before reviewing.'};
      prepare();
      return {ready:true, kind:'inquiry_preview', submitted:false, text:body.value,
        nextStep:'Review with the customer, then use the native form if authorized and supported. Complete Shopify verification or hand off to the customer.'};
    }
  });
  const reviewButton = document.createElement('button');
  reviewButton.type = 'button';
  reviewButton.className = 'button';
  reviewButton.textContent = 'Review request before sending';
  const review = document.createElement('pre');
  review.hidden = true;
  review.tabIndex = -1;
  review.style.cssText = 'white-space:pre-wrap;overflow-wrap:anywhere;font:inherit;padding:20px;border:1px solid #91c5bf;background:#f3f8f7;max-height:420px;overflow:auto';
  review.setAttribute('aria-label','Request preview — not sent');
  button.before(reviewButton, review);
  reviewButton.addEventListener('click', () => {
    const result = window.cateringInquiry.preview();
    review.hidden = false;
    review.textContent = result.ready ? 'PREVIEW ONLY — not sent, booked or paid.\n\n' + result.text : result.message;
    review.focus();
  });
  if (result?.dataset.requestResult === 'success') reviewButton.hidden = true;
  form.addEventListener('submit', event => {
    const ready = window.cateringRequestValidate();
    if (!ready || !form.reportValidity()) {
      event.preventDefault();
      feedback.textContent = 'Please check your selections and required fields before sending.';
      feedback.focus();
      return;
    }
    prepare();
    saveDraft();
    feedback.textContent = 'Sending your request. Complete any verification Shopify asks for.';
    // Allow Shopify's native POST and bot protection to run. Never use form.submit().
  });
  const clearReview = () => { feedback.textContent = ''; review.hidden = true; review.textContent = ''; };
  form.addEventListener('input', clearReview);
  form.addEventListener('change', clearReview);
})();
